
import { defineComponent, PropType } from 'vue'

// ! DO NOT UPDATE without referring to https://github.com/DeepSourceCorp/asgard/blob/master/contrib/stripe/biller.py#L28
export enum CardBrands {
  amex = 'American Express',
  diners = 'Diners Club',
  unionpay = 'UnionPay',
  discover = 'Discover',
  jcb = 'JCB',
  mastercard = 'MasterCard',
  visa = 'Visa',
  unknown = 'Unknown'
}

export default defineComponent({
  name: 'UI2PaymentInfoCard',
  props: {
    brand: {
      type: String as PropType<CardBrands>,
      default: CardBrands.unknown
    },
    endingIn: {
      type: String,
      default: '0000'
    }
  },
  data() {
    return {
      showUpdateCardModal: false
    }
  },
  computed: {
    cardBrandIcon() {
      const CARD_BRAND_ICON_NAME_MAP = {
        [CardBrands.amex]: require('~/assets/images/payments/amex.png'),
        [CardBrands.diners]: require('~/assets/images/payments/diners.png'),
        [CardBrands.unionpay]: require('~/assets/images/payments/union.png'),
        [CardBrands.discover]: require('~/assets/images/payments/discover.png'),
        [CardBrands.jcb]: require('~/assets/images/payments/jcb.png'),
        [CardBrands.visa]: require('~/assets/images/payments/visa.png'),
        [CardBrands.mastercard]: require('~/assets/images/payments/mastercard.png'),
        [CardBrands.unknown]: require('~/assets/images/payments/stripe.png')
      }

      return CARD_BRAND_ICON_NAME_MAP[this.brand] ?? CARD_BRAND_ICON_NAME_MAP[CardBrands.unknown]
    }
  }
})
